import { lazy, Suspense } from "react";
import './App.css';
import AdminGate from './Components/Admin/AdminGate';
import Navbar from './Components/Navbar/Navbar';
import { AdminIsLoggedProvider } from './Contextos/AdminContext';
import { ItemsProvider } from './Contextos/CartContext';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Footer from './Components/Footer/Footer';
import WhatsappWidget from './Components/WhatsappWidget/WhatsappWidget';
import InConstruction from './Components/InConstruction/InConstruction';
const Home = lazy(() => import('./Routes/Home/Home'));
const ItemListContainer = lazy(() => import('./Routes/ItemListContainer/ItemListContainer'));
const ItemDetailContainer = lazy(() => import('./Routes/ItemDetailcontainer/ItemDetailContainer'));
const Contacto = lazy(() => import('./Routes/Contacto/Contacto'));
const AccesoAdmin = lazy(() => import('./Components/AccesoAdmin/AccesoAdmin'));
const Cart = lazy(() => import('./Components/Cart/Cart'));
const FeedbackCompra = lazy(() => import('./Components/feedbackCompra/FeedbackCompra'));
const ObtenerOrdenes = lazy(() => import('./Components/ObtenerOrdenes/ObtenerOrdenes'));
const AdminPanel = lazy(() => import('./Components/Admin/AdminPanel'));
const ObtenerOrden = lazy(() => import('./Components/ObtenerOrden/ObtenerOrden'));

function App() {

  const inConstruction = false;

  return (

    <div>
      {inConstruction ? (
        <InConstruction />
      ) : (
        <div>
          <HashRouter>
            <AdminIsLoggedProvider>
              <ItemsProvider>
                <nav className="site-navigation">
                  <Navbar />
                </nav>
                <Suspense fallback={<p role="status">Cargando...</p>}>
                <Routes>
                  <Route exact path='/' element={<Home />} />
                  <Route exact path="/tienda" element={<ItemListContainer />} />
                  <Route path='/admin/*' element={<AdminGate><AdminPanel /></AdminGate>} />
                  <Route exact path='/login' element={<AccesoAdmin />} />
                  <Route exact path="/tienda/producto/:id" element={<ItemDetailContainer />} />
                  <Route exact path='/contacto' element={<Contacto />} />
                  <Route exact path='/carrito' element={<Cart />} />
                  <Route exact path='/feedback/:compraEf' element={<FeedbackCompra />} />
                  <Route exact path='/obtenerOrdenes/' element={<AdminGate><ObtenerOrdenes /></AdminGate>} />
                  <Route exact path='/obtenerOrden/:idOrdenComprador' element={<ObtenerOrden />} />
                </Routes>
                </Suspense>
                <WhatsappWidget />
                <footer>
                  <Footer />
                </footer>
              </ItemsProvider>
            </AdminIsLoggedProvider>
          </HashRouter>
        </div>
      )}
    </div>
  );
}

export default App;
